import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useState, useEffect } from 'react';
import Iconify from 'src/components/iconify';
import { useBoolean } from 'src/hooks/use-boolean';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import CreateIssuePaymentModal from './generate-payroll-create-issue-payment-mdoal';
import EditableCell from './genrate-payroll-create-emp-card-edit';
import HoursTable from './genrate-payroll-create-hour';
import { deductionCategories } from './payroll-data';
import PayrollDeductionsAccordion from './genrate-payroll-create-deduction-org';

const PayrollEmployeeCard = ({ employee, loading, bankInformation, employees, selectedDate, netWeeklyPaid, totalDeductions  ,saveTrigger}) => {
  console.log("🚀 ~ ><><><> totalDeductions:", totalDeductions)
  const [editing, setEditing] = useState(false);
  const [deductions, setDeductions] = useState(employee.deductions || {});
  const [loadingTaxData, setLoadingTaxData] = useState(false); 
  const [grossAmount, setGrossAmount] = useState(parseFloat(employee.grossAmount) || 0);
  const [currentTotalDeductions, setCurrentTotalDeductions] = useState(parseFloat(totalDeductions) || 0);
  const [netPay, setNetPay] = useState(netWeeklyPaid); 
  const add = useBoolean();

  useEffect(() => {
    if (saveTrigger) {
      console.log("🚀 ~ useEffect ~ saveTrigger:", saveTrigger)
      handleUpdateDeductions(employee.id, deductions);
    }
  }, [saveTrigger]);



const calculateNetPay = (updatedDeductions, fieldName, oldValue, newValue) => {
  const convertToNumber = (val) => {
    if (!val) return 0;
    if (typeof val === 'string') {
      return parseFloat(val.replace(/[^\d.-]/g, '')) || 0;
    }
    return parseFloat(val) || 0;
  };
  
  // Get the difference between the old and new value
  const oldValueNum = convertToNumber(oldValue);
  const newValueNum = convertToNumber(newValue);
  const difference = newValueNum - oldValueNum;
  const updatedTotalDeductions = difference;
  setCurrentTotalDeductions(updatedTotalDeductions);
  
  // Calculate new net pay by subtracting the updated total deductions from weekly paid
  const baseNetPay = parseFloat(netWeeklyPaid);
  const newNetPay = baseNetPay - updatedTotalDeductions;
  setNetPay(`$${newNetPay.toFixed(2)}`);
  
  console.log("🚀 ~ calculateNetPay ~ difference:", difference)
  console.log("🚀 difference ~baseNetPay ~ newNetPay: ~ difference:", difference, baseNetPay, newNetPay)
  return updatedTotalDeductions;
};

  const handleEdit = () => {
    setEditing(true);
  };

  const handleUpdateDeductions = async (employeeId, updatedDeductions) => {
    try {
      const toNumber = (value) => {
        if (value == null || value === "") {
          return 0;
        }
        const number = parseFloat(value?.replace(/[^\d.-]/g, ''));
        return isNaN(number) ? 0 : number;
      };
      
      // When editing, use the calculated net pay
      const finalNetPay = editing 
        ? parseFloat(netWeeklyPaid) - currentTotalDeductions
        : parseFloat(netWeeklyPaid);

      const payload = {
        employee_data: [
          {
            employee_id: employeeId,
            type: 'manual',
            weekly_time_sheet_date: selectedDate,
            tax_year: new Date().getFullYear(),
            city: '1', // Assuming fixed values for city and state
            state: '2',
            pay_period: 'weekly',
            gross_wages: grossAmount || '0',
            net_pay: finalNetPay, 
            pre_tax_deductions: toNumber(updatedDeductions.preTaxDeductions || '0'),
            total_employee_tax_liability: toNumber(updatedDeductions.totalEmployeeTaxLiability || '0'),
            total_employer_tax_liability: toNumber(updatedDeductions.totalEmployerTaxLiability || '0'),
            federal_income_tax: toNumber(updatedDeductions.federalIncomeTax || '0'),
            social_security_employee: toNumber(updatedDeductions.ssEmployee || '0'),
            social_security_employer: toNumber(updatedDeductions.ssEmployer || '0'),
            medicare_employee: toNumber(updatedDeductions.medicareEmployee || '0'),
            medicare_employer: toNumber(updatedDeductions.medicareEmployer || '0'),
            state_income_tax: toNumber(updatedDeductions.stateIncomeTax || '0'),
            state_unemployment_tax: toNumber(updatedDeductions.stateUnemploymentTax || '0'),
            local_income_tax: toNumber(updatedDeductions.localIncomeTax || '0'),
            roth401k: toNumber(updatedDeductions.roth401k || '0'),
            union_dues: toNumber(updatedDeductions.unionDues || '0'),
            charitable_contributions: toNumber(updatedDeductions.charitableContributions || '0'),
            loan_repayments: toNumber(updatedDeductions.loanRepayments || '0'),
          },
        ],
      };
  
      const response = await postRequest(
        `${endpoints.accounting.payroll.generate_payroll.post_deduction_tax}`,
        payload
      );
      
      if (response) {
        console.log('Deductions updated successfully');
      } else {
        console.error('Failed to update deductions');
      }
    } catch (error) {
      console.error('Error updating deductions:', error);
    }
  };
  
  const handleSave = async () => {
    setEditing(false);
    await handleUpdateDeductions(employee.id, deductions);
  };

  // Handle changes to deduction fields
  const handleChange = (field, value) => {
    const updatedDeductions = {
      ...deductions,
      [field]: value,
    };
    setDeductions(updatedDeductions);
    calculateNetPay(updatedDeductions, field, deductions[field], value);
  };
  
  useEffect(() => {
    setNetPay(netWeeklyPaid);
    const fetchTaxData = async () => {
      if (employee && employee.id) {
        setLoadingTaxData(true);
        try {
          console.log(employee.id);
        } catch (error) {
          console.error('Error fetching tax data:', error);
        } finally {
          setLoadingTaxData(false); 
        }
      }
    };
    fetchTaxData();
  }, [employee, netWeeklyPaid]); 

  return (
    <Card sx={{ mb: 3, mx: 2 }}>
      <CardContent>
        {loadingTaxData ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <CircularProgress size={50} />
            <Typography>Loading tax data...</Typography>
          </Box>
        ) : (
          <>
            <Grid container spacing={2} sx={{ bgcolor: '#919EAB14' }}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: 'flex', mb: 1 }}>
                  <Typography variant="subtitle2" sx={{ width: '50%', color: 'text.secondary' }}>
                    Employee Name
                  </Typography>
                  <Typography variant="body2" sx={{ width: '50%' }}>
                    {employee.name}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box sx={{ display: 'flex', mb: 1 }}>
                  <Typography variant="subtitle2" sx={{ width: '50%', color: 'text.secondary' }}>
                    Gross Amount Earned
                  </Typography>
                  <Typography variant="body2" sx={{ width: '50%' }}>
                    {employee.grossAmount}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: 'flex', mb: 1 }}>
                  <Typography variant="subtitle2" sx={{ width: '50%', color: 'text.secondary' }}>
                    Net Weekly Paid Wage
                  </Typography>
                  <Typography variant="body2" sx={{ width: '50%' }}>
                    {netPay}
                  </Typography>
                </Box>
              </Grid>
              
            </Grid>
            <Divider sx={{ my: 3 }} />
            <Grid container spacing={4}>
              <HoursTable
                overtime={employee.overtimeHours}
                standard={employee.standardHours}
                employee={employee}
              />
            </Grid>
            <Divider sx={{ my: 3 }} />

            {editing && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <IconButton onClick={handleSave}>
                  <Iconify icon="material-symbols:bookmark-added-outline-rounded" />
                </IconButton>
              </Box>
            )}

            {!editing && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <IconButton onClick={handleEdit}>
                  <Iconify icon="solar:pen-bold" />
                </IconButton>
              </Box>
            )}

            <Grid item xs={12}>
              <Card variant="outlined" sx={{ bgcolor: '#fafafa' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>
                    DEDUCTIONS
                  </Typography>
                  <PayrollDeductionsAccordion
                    deductionCategories={deductionCategories}
                    deductions={deductions} // Pass updated deductions data
                    editing={editing}
                    handleChange={handleChange}
                    EditableCell={EditableCell}
                  />
                </CardContent>
              </Card>
            </Grid>
            <CreateIssuePaymentModal
              open={add.value}
              onClose={add.onFalse}
              employees={employees}
              bankInformation={bankInformation}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};
export default PayrollEmployeeCard;